import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'
import { lightweight, standalone, type SymbolProps } from '../../spritesheetUtils'

const ID = 'bandcamp-third-party-glyph-icon'

export function BandCampSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <g>
        <path
          fillRule="evenodd"
          d="M10.386 7c7.135.005 14.269.004 21.403.004H32a.08.08 0 0 0-.016.022l-.007.015-.002.002a.087.087 0 0 0-.014.028l-.137.243-.135.245c-1.406 2.623-2.81 5.247-4.217 7.87-1.48 2.762-2.963 5.524-4.443 8.287.121-.323.204-.662.262-1.014-.029-.005-.043-.01-.057-.01l-1.656-.001c-.07 0-.084.034-.094.095-.073.408-.217.786-.48 1.112-.591.736-1.646.802-2.359.442-.518-.262-.828-.707-1.01-1.243-.308-.911-.286-1.832-.026-2.749.143-.505.414-.932.866-1.221.442-.284.93-.353 1.445-.308.815.071 1.416.604 1.56 1.408.016.086.047.107.13.107.525-.004 1.05-.002 1.576-.002.032 0 .065-.004.1-.006 0-.029.002-.048 0-.066l-.021-.145c-.163-1.11-.755-1.904-1.777-2.357-.944-.418-1.931-.47-2.93-.249-1.107.245-1.917.889-2.427 1.903-.29.573-.434 1.187-.484 1.826-.062.791 0 1.568.281 2.316.39 1.032 1.082 1.773 2.125 2.156.738.27 1.501.312 2.273.194.915-.139 1.674-.544 2.225-1.296l-.671 1.252c-.058.107-.127.13-.236.13-1.138-.003-2.277-.002-3.415-.002H.241c-.08 0-.16.008-.241.012v-.037c.373-.688.749-1.374 1.119-2.063l7.039-13.124c.64-1.194 1.282-2.386 1.917-3.582.073-.136.15-.194.311-.194Zm-1.748 7.509H6.936c.02.019.022.05.01.074v-.003c.004-.005.003-.002.001 0l-.003.008-.009.015c.002.032-.017.065-.058.065a.054.054 0 0 1-.047-.025c.005.573.013 3.697.017 6.759l.001.631.001.933v.605l.001.295.001 1.874H8.55v-1.107c.023.013.03.015.034.02a.315.315 0 0 1 .023.038c.223.41.547.713.964.915.649.314 1.343.38 2.05.348a3.093 3.093 0 0 0 1.692-.57c.628-.448 1.029-1.064 1.275-1.783.377-1.106.403-2.231.126-3.362-.175-.716-.496-1.362-1.035-1.876-.863-.822-1.91-1.091-3.062-.925a2.738 2.738 0 0 0-1.925 1.19c-.009.013-.024.02-.054.044v-4.163Zm2.216 4.296.171.008c.87.07 1.422.578 1.767 1.341.32.712.374 1.462.26 2.227-.066.434-.194.848-.432 1.22-.453.71-1.119 1-1.938.938-1.02-.079-1.607-.698-1.921-1.624a3.223 3.223 0 0 1-.132-.556c-.035-.23-.045-.463-.055-.581.01-.713.089-1.295.362-1.838.43-.855 1.228-1.195 2.089-1.127l-.171-.008Z"
          clipRule="evenodd"
        />
      </g>
    </symbol>
  )
}

const BandCampStandaloneContent = standalone(BandCampSymbol, ID)

export const Bandcamp = styled(function BandCampStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-bandcamp">
      <BandCampStandaloneContent />
    </Icon>
  )
})``

export const BandcampLightweight = styled(function BandCampComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-bandcamp">
      {lightweight(ID)}
    </Icon>
  )
})``
